//扩展httpr

var ajax = require('ajax')
const Htpr = {}

var get_fn = function(url, params, cb) {
    if (typeof params == 'function') {
        cb = params
        params = {}
    }
    getSgin(function() {
        ajax(url).get(params, function(err, result) {
            if (err) return cb(err)
            cb && cb(null, JSON.parse(result))
        })
    })
}

var post_fn = function(url, params, cb) {
    if (typeof params == 'function') {
        cb = params
        params = {}
    }
    getSgin(function() {
        ajax(url).post(params, function(err, result) {
            if (err) return cb(err)
            cb && cb(null, JSON.parse(result))
        })
    })
}

Htpr.install = function(Vue) {
    var get = function(url, params, cb) {
        get_fn(url, params, cb)
    }

    var post = function(url, params, cb) {
        post_fn(url, params, cb)
    }
    Vue.prototype.$httpr = {
        get: get,
        post: post
    }
}

var getSgin = function(callback) {
        callback && callback()
    }
    //--------------------------------------------------------------------------------------------------------------------------------------------

module.exports = {
    default: Htpr,
    getSgin: getSgin,
    get: get_fn,
    post: post_fn,
};